import React from 'react'
import { connect } from 'react-redux'
import { Dropdown } from 'semantic-ui-react'
import { DEFAULT_LOCALE } from '../../constants'


const categoryToOption = cat => ({
  key: cat.id, value: cat.id,
  text: cat.locales[DEFAULT_LOCALE].name,
})

class GeoCategoriesDropdown extends React.Component {
  render() {
    const { geoCategories, value, onChange, name } = this.props
    const categoryOptions = Object.values(geoCategories).map(categoryToOption)
    return <Dropdown
      selection multiple search fluid
      name={name}
      value={value}
      onChange={onChange}
      options={categoryOptions}
    />
  }
}

const mapStateToProps = state => ({ geoCategories: state.geoCategories })

export default connect(mapStateToProps)(GeoCategoriesDropdown)
